export enum BuilderAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    ADD_BUILDER_LIST = "ADD_BUILDER_LIST",
    UPDATE_BUILDER_LIST = "UPDATE_BUILDER_LIST",
    UPDATE_BUILDER_SEARCH_REQ = "UPDATE_BUILDER_SEARCH_REQ",
    SET_UPDATE_BUILDER = "SET_UPDATE_BUILDER",
}